/* eslint-disable prettier/prettier, react/prop-types, import/no-cycle */
import { Form, Input, Select } from "antd"
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { Button } from "../../components/buttons/buttons";
import { DataSubmit, DataUpdate, CreateVendorEngineer } from "../../redux/engineers/actionCreator";
import { DataRead } from "../../redux/countries/actionCreator";

export function AddEditEngineer({ data, handleClose, isVendorEng = false }) {

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { loading, add_vendor_eng_loading: vendorLoading } = useSelector(store => store.engineer)
    const country = useSelector(store => store.country);

    const handleSubmit = (values) => {
        if (data) {
            dispatch(DataUpdate(data.id, values, (isSuccess) => {
                if (isSuccess) {
                    form.resetFields();
                    handleClose();
                }
            }))
        } else {
            // eslint-disable-next-line
            if (isVendorEng) {
                dispatch(CreateVendorEngineer({ ...values, role_id: 3 }, (isSuccess) => {
                    if (isSuccess) {
                        form.resetFields();
                        handleClose();
                    }
                }))
            } else {
                dispatch(DataSubmit({ ...values, role_id: 3 }, (isSuccess) => {
                    if (isSuccess) {
                        form.resetFields();
                        handleClose();
                    }
                }))
            }
        }
    }

    React.useEffect(() => {
        dispatch(DataRead())
        // eslint-disable-next-line
    }, []);

    return <Form
        layout="vertical"
        initialValues={data}
        form={form}
        onFinish={handleSubmit}
    >
        <Form.Item label="First Name" name="name" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter first name" />
        </Form.Item>

        <Form.Item label="Last Name" name="last_name" rules={[{ required: true }]}>
            <Input className="rounded-6" placeholder="Enter last name" />
        </Form.Item>

        <Form.Item label="Email Id" name="email_id" rules={[{ required: true, type: 'email' }]}>
            <Input type="email" className="rounded-6" disabled={data} placeholder="Enter email id" />
        </Form.Item>

        {['https://jobs.thawe.ae', 'http://localhost:3000'].includes(window.location.origin) && <Form.Item label="Country" name="country_id">
            <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                className="[&>div]:px-[20px] [&>div]:bg-white dark:[&>div]:bg-white10 [&>div]:h-[50px] [&>div]:border-normal dark:[&>div]:border-white10 [&>div]:leading-[48px] [&>div]:rounded-6 [&>div>.ant-select-selection-item]:leading-[48px]"
                placeholder="Please select country"
                loading={country?.loading}
                options={country?.data ?? []}
            />
        </Form.Item>}

        <Form.Item>
            <div className="flex items-center min-md:justify-end justify-center mt-[15px]">
                {!data && <Button
                    className="bg-regularBG dark:bg-regularBGdark h-[38px] ltr:mr-[20px] rtl:ml-[20px] px-[22px] text-[15px] text-body dark:text-white60 hover:text-light font-normal border-regular dark:border-white10"
                    onClick={() => {
                        return form.resetFields();
                    }}
                >
                    Reset
                </Button>}
                <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading || vendorLoading}
                    className="bg-primary hover:bg-primary-hover h-[38px] px-[22px] text-[15px] text-white dark:text-white87 font-normal border-primary"
                >
                    {data ? "Update" : "Create"}
                </Button>
            </div>
        </Form.Item>
    </Form>
}
